import { FindColorsFilterOptionsOutput } from '../../../services/modules/filterOptions/filterOptions.types';
import { OfflineDatabaseColor } from '../database/offlineDatabase/types/offlineDatabaseColor.types';

export class OfflineColorTransformers {
  static toFilterOptionsColor(
    data: OfflineDatabaseColor,
  ): FindColorsFilterOptionsOutput['data'][0] {
    return {
      id: data.id,
      code: data.code,
      name: data.name,
    };
  }
}
